import { Routes } from '@angular/router';
import { adminGuard, authGuard } from './core/guards';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Tableau de bord',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.DashboardPage),
      },
      {
        path: 'documents',
        title: 'Documents',
        loadComponent: () => import('./features/documents/documents').then((m) => m.DocumentsPage),
      },
      {
        path: 'documents/:id',
        title: 'Document',
        loadComponent: () =>
          import('./features/documents/document-detail').then((m) => m.DocumentDetailPage),
      },
      {
        path: 'annuaire',
        title: 'Annuaire',
        loadComponent: () => import('./features/directory/directory').then((m) => m.DirectoryPage),
      },
      {
        path: 'alertes',
        title: 'Alertes',
        loadComponent: () => import('./features/alerts/alerts').then((m) => m.AlertsPage),
      },
      {
        path: 'supervision',
        title: 'Supervision',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/supervision/supervision').then((m) => m.SupervisionPage),
      },
      {
        path: 'administration',
        title: 'Administration',
        canActivate: [adminGuard],
        loadComponent: () => import('./features/admin/admin').then((m) => m.AdminPage),
      },
      {
        path: 'administration/documentation-api',
        title: "Documentation de l'API",
        canActivate: [adminGuard],
        loadComponent: () => import('./features/api-docs/api-docs').then((m) => m.ApiDocsPage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
